import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "../me/index.js";
import { RueckfrageGastgeber } from "./VerwerfenRueckfrage.js";
import { StrikteEbene, useImModal, useStrikteWege } from "./strikteHuelle.js";
import "./Modal.css";
/** Die vier Stufen in Pixeln des Entwurfs — `me-dialog` rechnet sie selbst in rem um. */
const BREITE_PX = {
    standard: 480,
    mittel: 640,
    breit: 900,
    weit: 1200,
};
export function Modal(p) {
    const imModal = useImModal();
    const breitePx = BREITE_PX[p.breite ?? "standard"];
    /*
     * Die Wege hinaus (Riegel am Rahmen, natives Schliessen abgefangen, Öffnen im selben
     * Commit) stehen seit dem Paket „Editor-Arbeitsdialog“ (09.10.2026) gemeinsam mit dem
     * `Arbeitsdialog` in strikteHuelle.tsx — dort auch die Arbeitsteilung am Riegel. Die
     * Fokus-Rückgabe an den Auslöser beim Aushängen macht me-dialog selbst (aff0190).
     */
    const { anker, steuerung } = useStrikteWege(p);
    /*
     * `strikt`: Ein Klick auf den Schleier schliesst NICHT (das Element prüft das selbst),
     * das Kreuz im Kopf bleibt sichtbar und läuft über `onAbbrechen` (Entscheid 36).
     * `offen` bleibt fest auf true — das Modal ist offen, solange es eingehängt ist.
     * Die Klasse `ki-modal` am Host ist nur Kennzeichen (die Einklapp-Regel der Verwaltung
     * nimmt ihn aus, Verwaltung.css); die Optik kommt vom Element.
     * `unter="seitlich"` (Entscheid Dirk 14): Passt der Subdialog nicht neben seine Eltern
     * (weite Maske 1200 + 480 auf 1280 px, Befund 4), stapelt `me-dialog` ihn selbst.
     * Den zugänglichen Namen gibt das Element seiner Ebene aus dem Titel — als
     * `aria-labelledby` und zusätzlich als `aria-label` (für Prüfwerkzeuge, die dem Verweis in
     * den Slot nicht folgen); ein eigenes `aria-label` am Host braucht es nicht mehr.
     * Im Inhalt einer anderen Hülle wird das Modal per Portal an <body> gezeichnet
     * (`StrikteEbene`, Review K1/K2).
     */
    return (_jsx(StrikteEbene, { imModal: imModal, children: _jsxs(Dialog, { ref: steuerung, offen: true, strikt: true, lage: "rechts", breite: breitePx, unter: p.gestapelt === true ? "stapel" : "seitlich", className: "ki-modal", titel: _jsx("span", { ref: anker, children: p.titel }), children: [p.children, _jsx(RueckfrageGastgeber, {})] }) }));
}
/**
 * Die Fußleiste eines strikten Modals — Speichern links, Abbrechen rechts, in jeder Maske
 * dieselbe Reihenfolge und dieselben Wörter.
 *
 * Sie steht hier und nicht in jeder Maske abgeschrieben, weil sie die Hausregel TRÄGT:
 * Solange jede Maske ihre zwei Knöpfe selbst zeichnete, konnte eine davon ein drittes
 * „Schliessen" dazustellen.
 */
export function ModalFuss(p) {
    /*
     * `slot="fuss"`: Der Fuss liegt als Kind von `Modal` im Inhalt, und `me-dialog` verteilt
     * ihn in seine Fußzeile (klebend, nur der Inhalt rollt). Dafür muss `ModalFuss`
     * UNMITTELBARES Kind von `Modal` sein — so steht er in allen Masken. `display: contents`
     * macht die zwei Knöpfe selbst zu den Kindern der Knopfzeile des Elements.
     */
    return (_jsxs("div", { slot: "fuss", className: "ki-modal__aktionen", style: { display: "contents" }, children: [_jsx("button", { type: "button", className: "ki-modal__primaer", disabled: p.speichernGesperrt === true, ...(p.speichernLabel === undefined ? {} : { "aria-label": p.speichernLabel }), onClick: p.onSpeichern, children: p.speichernText }), p.nurSchliessen !== true && (_jsx("button", { type: "button", className: "ki-modal__knopf", disabled: p.abbrechenGesperrt === true, onClick: p.onAbbrechen, children: "Abbrechen" }))] }));
}
// Die Rückfrage vor dem Abbrechen steht seit ME-Etappe 3 als Subdialog in
// VerwerfenRueckfrage.tsx; der Name bleibt hier erreichbar.
export { darfAbbrechen } from "./VerwerfenRueckfrage.js";
//# sourceMappingURL=Modal.js.map